export default __webpack_public_path__ + "static/media/img-intro-kahsh-labs.a6c3a3f0.png";